import "../../assets/styles/header.css";
import "../../assets/styles/custom-nav.css";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLang } from "../../redux/actions/settings";
import { FormattedMessage } from "react-intl";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import eclearLogo from "../../assets/images/logo-eclear.png";
import en_locale from "../../translations/en.json";
import de_locale from "../../translations/de.json";

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const menuInitialState = {
    VAT: "hide",
    Customs: "hide",
    Solutions: "hide",
    Store: "hide",
    Newsroom: "hide",
    AboutUs: "hide",
  };
  const [menuVisible, setMenuVisible] = useState(menuInitialState);

  const dispatch = useDispatch();

  const lang = useSelector((state) => state.settings.lang);

  const messages = {
    de: de_locale,
    en: en_locale,
  };

  const navigate = useNavigate();

  useEffect(() => {
    navigate(window.location.pathname.replace(/(\/(en|de))\b/, `/${lang}`));
  }, [lang]);

  return (
    <header className="page-header">
      <div className="header content">
        {/* <span data-action="toggle-nav" className="action nav-toggle">
          <span>Toggle Nav</span>
        </span> */}
        <a
          className="logo"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = `https://eclear.com/${lang}/`;
          }}
          title=""
          aria-label="store logo"
        >
          <img src={eclearLogo} title="" alt="" width={114} />
        </a>
        <div style={{ flex: "0 0 50%" }}>
          <div
            data-content-type="html"
            data-appearance="default"
            data-element="main"
            data-decoded="true"
          >
            <div className="custom-navigation">
              <div className="menu-item">
                <a href="javascript:void(0)">
                  {" "}
                  <FormattedMessage id="PRODUCTS" />
                </a>
                <div className="dropdown">
                  <div className="group-menu">
                    <a className="menu-title">
                      {" "}
                      <FormattedMessage id="For marketplaces and platforms" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["clearVat link"]}
                    >
                      <span className="first_word"> ClearVAT </span>{" "}
                      <FormattedMessage id="Crossborder" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["clearCustoms link"]}
                    >
                      <span className="first_word"> ClearCustoms </span>{" "}
                      <FormattedMessage id="Borderfree" />
                    </a>
                  </div>
                  <div className="group-menu">
                    <a className="menu-title">
                      <FormattedMessage id="CorporateTax" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["vatRules link"]}
                    >
                      {" "}
                      <span className="first_word"> VATRules </span>{" "}
                      <FormattedMessage id="Database for VAT Rates and Rules" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["fileVat link"]}
                    >
                      <span className="first_word"> FileVAT </span>{" "}
                      <FormattedMessage id="VAT declaration for EU-27, CH, NO, UK" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["checkVatId link"]}
                    >
                      <span className="first_word"> CheckVAT ID </span>{" "}
                      <FormattedMessage id="Audit-proof VAT ID Check" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu-item">
                <a>
                  <FormattedMessage id="Solutions" />
                </a>
                <div className="dropdown">
                  <div className="group-menu">
                    <a className="menu-title">
                      <FormattedMessage id="Integrations" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["plentyMarkets link"]}
                    >
                      plentymarkets
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["sap link"]}
                    >
                      SAP
                    </a>
                  </div>
                  <div className="group-menu">
                    <a className="menu-title">Partner</a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["worldline link"]}
                    >
                      Worldline
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu-item">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/store/${lang}`);
                  }}
                >
                  <FormattedMessage id="Store" />
                </a>
              </div>
              <div className="menu-item">
                <a href={messages[lang]["latestInformation link"]}>
                  <FormattedMessage id="Newsroom" />
                </a>
                <div className="dropdown">
                  <div className="group-menu">
                    <a className="menu-title">
                      <FormattedMessage id="News" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["latestInformation link"]}
                    >
                      <FormattedMessage id="Latest Information" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["events link"]}
                    >
                      <FormattedMessage id="Events" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["newsletter link"]}
                    >
                      <FormattedMessage id="Newsletter" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["eClearInMedia link"]}
                    >
                      <FormattedMessage id="eClear in the media" />
                    </a>
                  </div>
                  <div className="group-menu">
                    <a className="menu-title">
                      <FormattedMessage id="Special topics" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["crossBorderEcommerce link"]}
                    >
                      <FormattedMessage id="Cross-border E-Commerce" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["customsInfoNews link"]}
                    >
                      <FormattedMessage id="Customs - Info & News" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["vatInfoNews link"]}
                    >
                      <FormattedMessage id="VAT - Info & News" />
                    </a>

                    <a className="menu-title">
                      <strong>
                        <FormattedMessage id="Knowledge" />:
                      </strong>
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["ViDAlink"]}
                    >
                      <FormattedMessage id="ViDA" />
                    </a>

                    <a
                      className="first_second_word"
                      href={messages[lang]["EUDirectivesLink"]}
                    >
                      <FormattedMessage id="EUDirectives" />
                    </a>

                    <a
                      className="first_second_word"
                      href={messages[lang]["ioss link"]}
                    >
                      <FormattedMessage id="Import-One-Stop-Shop (IOSS)" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["oss link"]}
                    >
                      <FormattedMessage id="One-Stop-Shop (OSS)" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["CarbonBorderLink"]}
                    >
                      <FormattedMessage id="CarbonBorderAdjustment" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["internationalFinancialLink"]}
                    >
                      <FormattedMessage id="InternationFinancialReportingInEU" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["importCustomsGB link"]}
                    >
                      <FormattedMessage id="Import customs clearance in Great Britain" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["customRegulations link"]}
                    >
                      <FormattedMessage id="Customs regulations between Switzerland and the EU" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["blackFriday link"]}
                    >
                      <FormattedMessage id="Black Friday" />
                    </a>
                    <a className="menu-title">
                      <strong>Tech:</strong>
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["taxTechnology link"]}
                    >
                      <FormattedMessage id="Tax Technology" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["eCommerceTools link"]}
                    >
                      <FormattedMessage id="E-Commerce Tools" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu-item">
                <a href="https://eclear.com/company/">
                  <FormattedMessage id="About us" />
                </a>
                <div className="dropdown">
                  <div className="group-menu1">
                    <a
                      className="first_second_word"
                      href={messages[lang]["managementBoard link"]}
                    >
                      <FormattedMessage id="Management Board" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["supervisoryBoard link"]}
                    >
                      <FormattedMessage id="Supervisory Board" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["partners link"]}
                    >
                      <FormattedMessage id="Partners" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["locations link"]}
                    >
                      <FormattedMessage id="Locations" />
                    </a>
                    <a
                      className="first_second_word"
                      href={messages[lang]["career link"]}
                    >
                      <FormattedMessage id="Career" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          //mobile menu starts here...
        }
        <div className="custom-switcher-store mobile f768">
          <a
            href={`https://store.eclear.com/${lang}/`}
            className={lang === "en" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("en"));
            }}
          >
            EN{" "}
          </a>
          |
          <a
            href="https://store.eclear.com/de/"
            className={lang === "de" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("de"));
            }}
          >
            DE{" "}
          </a>
        </div>
        <div id="li-account-icon">
          <svg
            height="1em"
            width="1em"
            focusable="false"
            fill="currentColor"
            viewBox="0 0 24 24"
            role="img"
            aria-hidden="false"
            style={{ color: "#ffffff", marginRight: 20 }}
          >
            <title>
              <FormattedMessage id="Login" />
            </title>
            <path d="M21.645 22.866a28.717 28.717 0 0 0-6.46-7.817c-2.322-1.892-4.048-1.892-6.37 0a28.74 28.74 0 0 0-6.46 7.817.75.75 0 0 0 1.294.76 27.264 27.264 0 0 1 6.113-7.413A3.98 3.98 0 0 1 12 15.125a3.81 3.81 0 0 1 2.236 1.088 27.252 27.252 0 0 1 6.115 7.412.75.75 0 1 0 1.294-.76zM12 12.002A6.01 6.01 0 0 0 18.003 6 6.003 6.003 0 1 0 12 12.002zm0-10.505a4.502 4.502 0 1 1 0 9.005 4.502 4.502 0 0 1 0-9.005z" />
          </svg>
          <div className="menu-account" style={{}}>
            <a
              href="/customer/account/login/"
              id="button-login-account-menu"
              onClick={(e) => {
                e.preventDefault();
                if (window.location.host.includes("localhost")) {
                  window.location.href = "https://dev.eclear-solutions.com/";
                } else {
                  window.location.href = `/`;
                }
              }}
            >
              <FormattedMessage id="Sign In" />
            </a>
            <span
              style={{
                display: "flex",
                justifyContent: "space-around",
                fontSize: 12,
                textTransform: "uppercase",
                color: "#777777",
                alignItems: "baseline",
              }}
            >
              <FormattedMessage id="New Customer?" />{" "}
              <a
                href="/customer/account/create/"
                id="register-account-menu"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.location.host.includes("localhost")) {
                    window.location.href =
                      "https://dev.eclear-solutions.com/signup";
                  } else {
                    window.location.href = `/signup`;
                  }
                }}
              >
                <span style={{ color: "#54836b" }}>
                  <FormattedMessage id="Join Now" />{" "}
                </span>
              </a>
            </span>
          </div>
        </div>
        <div
          data-content-type="html"
          data-appearance="default"
          data-element="main"
          data-decoded="true"
        >
          <div className="nav-mobile">
            <button
              className="show-mobile-menu"
              onClick={() => {
                setIsDrawerOpen(true);
              }}
            >
              <MenuIcon
                className="menu-icon"
                style={{ color: "white", fontSize: "24px" }}
              />
            </button>
            <div className={`overlay fixed ${!isDrawerOpen && "hide"}`} />
            <div
              className={`sidebar-menu fixed showLeftToRight  ${
                !isDrawerOpen && "closeRightToLeft"
              }`}
            >
              <div className="head">
                <button
                  className="close-sidebar-menu"
                  type="button"
                  onClick={() => {
                    setIsDrawerOpen(false);
                    setMenuVisible(menuInitialState);
                  }}
                >
                  <CloseIcon style={{ color: "white", fontSize: "24px" }} />
                </button>
                <button
                  type="button"
                  className={`back ${
                    JSON.stringify(menuVisible) ===
                      JSON.stringify(menuInitialState) && "hide"
                  }`}
                  onClick={() => {
                    setMenuVisible(menuInitialState);
                  }}
                >
                  <KeyboardArrowLeftIcon
                    style={{ color: "white", fontSize: "24px" }}
                  />
                </button>
              </div>
              <div className="body">
                <div
                  className={`level0 ${
                    JSON.stringify(menuVisible) !==
                      JSON.stringify(menuInitialState) && "hide"
                  }`}
                >
                  <div className="subcategory-item">
                    <button
                      type="button"
                      className="show-child-category"
                      child={1}
                      onClick={() => {
                        setMenuVisible({ ...menuInitialState, VAT: "show" });
                      }}
                    >
                      <FormattedMessage id="PRODUCTS" />
                    </button>
                  </div>

                  <div className="subcategory-item">
                    <button
                      type="button"
                      className="show-child-category"
                      child={3}
                      onClick={() => {
                        setMenuVisible({
                          ...menuInitialState,
                          Solutions: "show",
                        });
                      }}
                    >
                      <FormattedMessage id="Solutions" />
                    </button>
                  </div>
                  <div className="subcategory-item">
                    <button
                      type="button"
                      className="show-child-category"
                      onClick={() => {
                        navigate(`/store/${lang}`);
                        setIsDrawerOpen(false);
                      }}
                    >
                      Store
                    </button>
                  </div>
                  <div className="subcategory-item">
                    <button
                      type="button"
                      className="show-child-category"
                      child={5}
                      onClick={() => {
                        setMenuVisible({
                          ...menuInitialState,
                          Newsroom: "show",
                        });
                      }}
                    >
                      <FormattedMessage id="Newsroom" />
                    </button>
                  </div>
                  <div className="subcategory-item">
                    <button
                      type="button"
                      className="show-child-category"
                      child={6}
                      onClick={() => {
                        setMenuVisible({
                          ...menuInitialState,
                          AboutUs: "show",
                        });
                      }}
                    >
                      <FormattedMessage id="About us" />
                    </button>
                  </div>
                </div>
                <div className="child-item">
                  <div className={`level1 ${menuVisible.VAT}`} child={1}>
                    <a className="child-item-title1" href="javascript:void(0)">
                      <FormattedMessage id="PRODUCTS" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="For marketplaces and platforms" />
                    </a>
                    <a
                      className="child-item-title"
                      child="1-1"
                      href={messages[lang]["clearVat link"]}
                    >
                      <span className="first_word"> ClearVAT </span>{" "}
                      <FormattedMessage id="Cross-border E-Commerce VAT-free" />
                    </a>
                    <a
                      className="child-item-title"
                      child="2-1"
                      href={messages[lang]["clearCustoms link"]}
                    >
                      <span className="first_word"> ClearCustoms </span>{" "}
                      <FormattedMessage id="Border-free commerce" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="CorporateTax" />
                    </a>
                    <a
                      className="child-item-title"
                      child="1-3"
                      href={messages[lang]["vatRules link"]}
                    >
                      <span className="first_word"> VAT Rules </span>{" "}
                      <FormattedMessage id="Database for VAT Rates and Rules" />
                    </a>
                    <a
                      className="child-item-title"
                      child="1-4"
                      href={messages[lang]["fileVat link"]}
                    >
                      <span className="first_word"> FileVAT </span>{" "}
                      <FormattedMessage
                        id="VAT
                      declaration for EU-27, CH, NO, UK"
                      />
                    </a>
                    <a
                      className="child-item-title"
                      child="1-2"
                      href={messages[lang]["spot link"]}
                    >
                      <span className="first_word"> SPOT </span>{" "}
                      <FormattedMessage id="Complete Compliance Control" />
                    </a>
                    <a
                      className="child-item-title"
                      child="1-5"
                      href={messages[lang]["checkVatId link"]}
                    >
                      <span className="first_word"> CheckVAT ID </span>{" "}
                      <FormattedMessage id="Audit-proof VAT ID Check" />
                    </a>
                  </div>

                  <div className={`level1 ${menuVisible.Solutions}`} child={3}>
                    <a className="child-item-title1">
                      <FormattedMessage id="Solutions" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="Integrations" />
                    </a>
                    <a
                      className="child-item-title"
                      child="3-1"
                      href={messages[lang]["plentyMarkets link"]}
                    >
                      plentymarkets
                    </a>
                    <a
                      className="child-item-title"
                      child="3-2"
                      href={messages[lang]["sap link"]}
                    >
                      SAP
                    </a>
                    <a className="child-item-title2">Partners</a>
                    <a
                      className="child-item-title"
                      child="3-3"
                      href={messages[lang]["worldline link"]}
                    >
                      Worldline
                    </a>
                  </div>
                  <div className={`level1 ${menuVisible.Newsroom}`} child={5}>
                    <a className="child-item-title1">
                      <FormattedMessage id="Newsroom" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="News" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-1"
                      href={messages[lang]["latestInformation link"]}
                    >
                      <FormattedMessage id="Latest information" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-2"
                      href={messages[lang]["events link"]}
                    >
                      <FormattedMessage id="Events" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-3"
                      href={messages[lang]["newsletter link"]}
                    >
                      <FormattedMessage id="Newsletter" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-4"
                      href={messages[lang]["eClearInMedia link"]}
                    >
                      <FormattedMessage id="eClear in the media" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="Special topics" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-5"
                      href={messages[lang]["crossBorderEcommerce link"]}
                    >
                      <FormattedMessage id="Cross-border e-commerce" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-6"
                      href={messages[lang]["customsInfoNews link"]}
                    >
                      <FormattedMessage id="Customs - Info & News" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-7"
                      href={messages[lang]["vatInfoNews link"]}
                    >
                      <FormattedMessage id="VAT - Info & News" />
                    </a>
                    <a className="child-item-title2">
                      <FormattedMessage id="Knowledge" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-9"
                      href={messages[lang]["ViDALink"]}
                    >
                      <FormattedMessage id="ViDA" />
                    </a>

                    <a
                      className="child-item-title"
                      child="5-9"
                      href={messages[lang]["EUDirectivesLink"]}
                    >
                      <FormattedMessage id="EUDirectives" />
                    </a>

                    <a
                      className="child-item-title"
                      child="5-8"
                      href={messages[lang]["ioss link"]}
                    >
                      <FormattedMessage id="Import-One-Stop-Shop (IOSS)" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-9"
                      href={messages[lang]["oss link"]}
                    >
                      <FormattedMessage id="One-Stop-Shop (OSS)" />
                    </a>

                    <a
                      className="child-item-title"
                      child="5-8"
                      href={messages[lang]["CarbonBorderLink"]}
                    >
                      <FormattedMessage id="CarbonBorderAdjustment" />
                    </a>

                    <a
                      className="child-item-title"
                      child="5-8"
                      href={messages[lang]["internationalFinancialLink"]}
                    >
                      <FormattedMessage id="InternationFinancialReportingInEU" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-11"
                      href={messages[lang]["importCustomsGB link"]}
                    >
                      <FormattedMessage id="Import customs clearance in Great Britain" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-12"
                      href={messages[lang]["customRegulations link"]}
                    >
                      <FormattedMessage id="Customs regulations between Switzerland and the EU" />
                    </a>

                    <a
                      className="child-item-title"
                      child="5-14"
                      href={messages[lang]["blackFriday link"]}
                    >
                      <FormattedMessage id="Black Friday" />
                    </a>
                    <a className="child-item-title2">Tech</a>
                    <a
                      className="child-item-title"
                      child="5-15"
                      href={messages[lang]["taxTechnology link"]}
                    >
                      <FormattedMessage id="Tax Technology" />
                    </a>
                    <a
                      className="child-item-title"
                      child="5-16"
                      href={messages[lang]["eCommerceTools link"]}
                    >
                      <FormattedMessage id="E-Commerce Tools" />
                    </a>
                  </div>
                  <div className={`level1 ${menuVisible.AboutUs}`} child={6}>
                    <a className="child-item-title1">About us</a>
                    <a
                      className="child-item-title"
                      child="6-1"
                      href={messages[lang]["managementBoard link"]}
                    >
                      <FormattedMessage id="Management Board" />
                    </a>
                    <a
                      className="child-item-title"
                      child="6-2"
                      href={messages[lang]["supervisoryBoard link"]}
                    >
                      <FormattedMessage id="Supervisory Board" />
                    </a>
                    <a
                      className="child-item-title"
                      child="6-3"
                      href={messages[lang]["partners link"]}
                    >
                      <FormattedMessage id="Partners" />
                    </a>
                    <a
                      className="child-item-title"
                      child="6-4"
                      href={messages[lang]["locations link"]}
                    >
                      <FormattedMessage id="Locations" />
                    </a>
                    <a
                      className="child-item-title"
                      child="6-5"
                      href={messages[lang]["career link"]}
                    >
                      <FormattedMessage id="Career" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-switcher-store mobile f767">
          <a
            href="#"
            className={lang === "en" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("en"));
            }}
          >
            EN{" "}
          </a>
          |
          <a
            href="https://store.eclear.com/de/"
            className={lang === "de" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("de"));
            }}
          >
            DE{" "}
          </a>
        </div>
        <a
          className="action subscribe primary request-demo-now-header"
          href={messages[lang]["contact link"]}
        >
          <FormattedMessage id="Contact" />
        </a>
        <div className="custom-switcher-store">
          <a
            href="https://store.eclear.com/en/stores/store/redirect/___store/en/___from_store/en/uenc/aHR0cHM6Ly9zdG9yZS5lY2xlYXIuY29tL2VuLz9fZ2w9MSUyQTF4bWE3ZWQlMkFfZ2NsX2F1JTJBTlRrNU5EQTNNelEyTGpFMk9USXhNRFl3TmpJLiZfZ2E9Mi4xMDQxMjYwODAuMTAzODk4MTAwNy4xNjk1Mjk2MDUxLTEwMTI4NTcxNzUuMTY1MDM4MTQ1Nw%2C%2C/"
            className={lang === "en" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("en"));
            }}
          >
            EN{" "}
          </a>
          |
          <a
            href="https://store.eclear.com/en/stores/store/redirect/___store/de/___from_store/en/uenc/aHR0cHM6Ly9zdG9yZS5lY2xlYXIuY29tL2RlLz9fZ2w9MSUyQTF4bWE3ZWQlMkFfZ2NsX2F1JTJBTlRrNU5EQTNNelEyTGpFMk9USXhNRFl3TmpJLiZfZ2E9Mi4xMDQxMjYwODAuMTAzODk4MTAwNy4xNjk1Mjk2MDUxLTEwMTI4NTcxNzUuMTY1MDM4MTQ1Nw%2C%2C/"
            className={lang === "de" && "current"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setLang("de"));
            }}
          >
            DE{" "}
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
